const Base_Url=process.env.REACT_APP_API_URL || "https://server.trademax1.com"
// const Base_Url="http://localhost:3001"

export default Base_Url
